import { isDefined } from "@clipboard-health/util-ts";

/**
 * Renders an exclusion's `reasons[]` as a compact one-liner: the first reason,
 * with "and N more" appended when there are additional reasons. Used in cells,
 * banners, and other constrained spaces — modals should render the full bullet list.
 *
 * Returns `fallback` (default `""`) when `reasons` is undefined or empty.
 */
export function formatReasonsSummary(
  reasons: readonly string[] | undefined,
  fallback = ""
): string {
  const [first, ...rest] = reasons ?? [];
  if (!isDefined(first)) {
    return fallback;
  }
  return rest.length > 0 ? `${first} and ${rest.length} more` : first;
}
